import { Linkable } from "@/components/blocks/Linkable";
import { useProductDetails } from "@/data/Content/ProductDetails";
import { useLocalization } from "@/data/Localization";
import { ContentContext } from "@/data/context/content";
import { getAttributesValueByIdentifier, getAttributeValueByIdentifier } from "@/utils/productAttributes";
import { Stack, Typography } from "@mui/material";
import { FC, useContext, useMemo } from "react";
import { BrandAndSeriesLinksSX } from "./styles/addToCartStack";

export const BrandAndSeriesLink: FC = () => {
	const { productAttrValues } = useContext(ContentContext) as ReturnType<typeof useProductDetails>;
    const productDetailNLS = useLocalization('productDetail');
    const {
        brands,
        brandsURLKeyword,
        brandsandserie,
        brandAndSerieURLKeyword,
    } = useMemo(()=>{
        return{
            brands : productAttrValues.Brands,
            brandsURLKeyword: productAttrValues.BrandsURLKeyword,
            brandsandserie: productAttrValues.BrandAndSerie,
            brandAndSerieURLKeyword: productAttrValues.BrandAndSerieURLKeyword
        }
    },[productAttrValues]);

    return brands || brandsandserie ? (
        <Stack direction="column" spacing={1}>
            {brands && brandsURLKeyword && 
                <Typography>
                    {productDetailNLS.BRAND.t()}
                    <Linkable href={`/${brandsURLKeyword}`} sx={BrandAndSeriesLinksSX}>{brands}</Linkable>
                </Typography>
            }
            {brandsandserie && brandAndSerieURLKeyword && 
                <Typography>
                    {productDetailNLS.BRANDSERIES.t()}
                    <Linkable href={`/${brandAndSerieURLKeyword}`} sx={BrandAndSeriesLinksSX}>{brandsandserie}</Linkable>
                </Typography>
            } 
        </Stack>
    ): null;
}